import { IAppointmentSlot } from '@sondermind/utilities/models-scheduling';

const TODAY = new Date(2024, 10, 1);
const TOMORROW = new Date(2024, 10, 3);
const DAY_AFTER_THAT = new Date(2024, 10, 6);
const A_WEEK_LATER = new Date(2024, 10, 7);
const AND_AFTER_THAT = new Date(2024, 10, 19);
const BUT_FURTHER_ON = new Date(2024, 10, 30);
const ALSO = new Date(2024, 11, 7);

export const TEST_APPOINTMENT_SLOTS: IAppointmentSlot[] = [
  {
    displayStartTime: new Date(TODAY.setHours(2)),
    utcStartTime: new Date(TODAY.setHours(2)),
    utcEndTime: new Date(TODAY.setHours(3))
  },
  {
    displayStartTime: new Date(TODAY.setHours(3)),
    utcStartTime: new Date(TODAY.setHours(3)),
    utcEndTime: new Date(TODAY.setHours(4))
  },
  {
    displayStartTime: new Date(TODAY.setHours(4)),
    utcStartTime: new Date(TODAY.setHours(4)),
    utcEndTime: new Date(TODAY.setHours(5))
  },
  {
    displayStartTime: new Date(TOMORROW.setHours(10)),
    utcStartTime: new Date(TOMORROW.setHours(10)),
    utcEndTime: new Date(TOMORROW.setHours(11))
  },
  {
    displayStartTime: new Date(TOMORROW.setHours(7)),
    utcStartTime: new Date(TOMORROW.setHours(7)),
    utcEndTime: new Date(TOMORROW.setHours(8))
  },
  {
    displayStartTime: new Date(TOMORROW.setHours(3)),
    utcStartTime: new Date(TOMORROW.setHours(3)),
    utcEndTime: new Date(TOMORROW.setHours(4))
  },
  {
    displayStartTime: new Date(TOMORROW.setHours(4)),
    utcStartTime: new Date(TOMORROW.setHours(4)),
    utcEndTime: new Date(TOMORROW.setHours(5))
  },
  {
    displayStartTime: new Date(TOMORROW.setHours(2)),
    utcStartTime: new Date(TOMORROW.setHours(2)),
    utcEndTime: new Date(TOMORROW.setHours(3))
  },
  {
    displayStartTime: new Date(DAY_AFTER_THAT.setHours(3)),
    utcStartTime: new Date(DAY_AFTER_THAT.setHours(3)),
    utcEndTime: new Date(DAY_AFTER_THAT.setHours(4))
  },
  {
    displayStartTime: new Date(TOMORROW.setHours(1)),
    utcStartTime: new Date(TOMORROW.setHours(1)),
    utcEndTime: new Date(TOMORROW.setHours(2))
  },
  {
    displayStartTime: new Date(DAY_AFTER_THAT.setHours(4)),
    utcStartTime: new Date(DAY_AFTER_THAT.setHours(4)),
    utcEndTime: new Date(DAY_AFTER_THAT.setHours(5))
  },
  {
    displayStartTime: new Date(A_WEEK_LATER.setHours(2)),
    utcStartTime: new Date(A_WEEK_LATER.setHours(2)),
    utcEndTime: new Date(A_WEEK_LATER.setHours(3))
  },
  {
    displayStartTime: new Date(A_WEEK_LATER.setHours(3)),
    utcStartTime: new Date(A_WEEK_LATER.setHours(3)),
    utcEndTime: new Date(A_WEEK_LATER.setHours(4))
  },
  {
    displayStartTime: new Date(A_WEEK_LATER.setHours(4)),
    utcStartTime: new Date(A_WEEK_LATER.setHours(4)),
    utcEndTime: new Date(A_WEEK_LATER.setHours(5))
  },
  {
    displayStartTime: new Date(A_WEEK_LATER.setHours(5)),
    utcStartTime: new Date(A_WEEK_LATER.setHours(5)),
    utcEndTime: new Date(A_WEEK_LATER.setHours(6))
  },
  {
    displayStartTime: new Date(A_WEEK_LATER.setHours(6)),
    utcStartTime: new Date(A_WEEK_LATER.setHours(6)),
    utcEndTime: new Date(A_WEEK_LATER.setHours(7))
  },
  {
    displayStartTime: new Date(A_WEEK_LATER.setHours(7)),
    utcStartTime: new Date(A_WEEK_LATER.setHours(7)),
    utcEndTime: new Date(A_WEEK_LATER.setHours(8))
  },
  {
    displayStartTime: new Date(AND_AFTER_THAT.setHours(11)),
    utcStartTime: new Date(AND_AFTER_THAT.setHours(11)),
    utcEndTime: new Date(AND_AFTER_THAT.setHours(12))
  },
  {
    displayStartTime: new Date(BUT_FURTHER_ON.setHours(11)),
    utcStartTime: new Date(BUT_FURTHER_ON.setHours(11)),
    utcEndTime: new Date(BUT_FURTHER_ON.setHours(12))
  },
  {
    displayStartTime: new Date(ALSO.setHours(11)),
    utcStartTime: new Date(ALSO.setHours(11)),
    utcEndTime: new Date(ALSO.setHours(12))
  }
];
